//#region libraries
import React from 'react';
// custom components
import { CustomSpinner } from '_atoms';

// bootstrap
import { Container, Row, Col, Button, Image } from 'react-bootstrap';

// tremor
import { Text } from '@tremor/react';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { selectCreateSupportDeskStatus, createSupportDesk } from '_redux/slices/messaging/messaging';
import { selectFirebaseInfo } from '_redux/slices/main-screen/user';

// utils
import { Colors } from '_styles';
import image from "_assets/images/support-desk/support-desk-mobile.png";
//#endregion
const SupportDeskOnboardingPage = (props) => {

    //#region redux
    const dispatch = useDispatch();
    const dbUser = useSelector(selectFirebaseInfo);
    const enrollStatus = useSelector(selectCreateSupportDeskStatus);
    //#endregion

    //#region functions
    //save new account into firebase DB
    const enroll = () => {
        if (dbUser && dbUser.details && dbUser.details.authority) {
            let supportDeskObject = {
                iata: dbUser.role !== "RETAILER" ? dbUser.details.authority : `RETAILER-${dbUser.firebaseId}`,
                lastOnline: new Date().toISOString(),
                status: 'online'
            };
            dispatch(createSupportDesk(supportDeskObject))
        }
    }
    //view question/answer
    const QuestionAnswer = (props) => {
        return (
            <div className='mt-3'>
                <p style={{ fontSize: 14, fontWeight: '600', color: Colors.PRM_LIGHT_BLUE }}>{props.question}</p>
                <Text>{props.answer}</Text>
            </div>
        )
    }
    //#endregion
    return (
        <Row>
            <Col xs={7}>
                <p style={{ fontSize: 32, opacity: 0.6, fontWeight: 'bold' }}>Welcome to Support Desks</p>
                <hr style={{ borderWidth: 0.8, borderColor: Colors.PRM_LIGHT_BLUE }} />

                <Container className='mt-5'>
                    <QuestionAnswer question={'What is support desk?'} answer={'Support desk is a messenger feature that allows passengers to communicate directly with airport staff. Each passenger who has booked their assistance using the PRM Assist app can now issues support tickets through a chat feature on the app. Improving communication between airport workers and passengers.'} />
                    <QuestionAnswer question={'Why use support desk?'} answer={'Support desk is the best possible way to communicate directly with passengers and improve operational efficency. While responding to passenger requests may take some time, overall the operational benefits surpass the time spent responding to support tickets, because dealing with passenger issues before departure date means that these challenges will not impact daily operations. Passengers will also feel more secure and overall happier with their service.'} />
                    <QuestionAnswer question={'How do I register and activate a support desk?'} answer={'Simply click the enroll button below and your support desk will be open for all passengers with active bookings.'} />
                    <QuestionAnswer question={'Can I cancel the support desk or opt out?'} answer={'Your support desk can be deactivated and turned offline at any time.'} />

                    <Button variant="primary" style={{ width: 300 }} className='mt-5' onClick={enroll}>{enrollStatus == 'loading' ? <CustomSpinner /> : `Enroll ${dbUser.role === "RETAILER" ? 'Retailer' : 'Airport'} in Support Desk Programme`}</Button>

                </Container>

            </Col>
            <Col style={{}}>
                <Image
                    src={image}
                    height={'450px'}
                    width={'450px'}
                />
            </Col>
        </Row>
    );
};

export default SupportDeskOnboardingPage;
